import React, { useMemo } from "react";
import { Col } from "@amzn/stencil-react-components/layout";
import { Text } from "../typography";
import DOMPurify from "dompurify";
import "./styles.scss";
import useArb from "../../hooks/use-arb";

interface SdaDetailsProps {
  startDateTime: string;
  address: string;
  publicText: string;
}

export const SdaDetails = ({ startDateTime, address, publicText }: SdaDetailsProps) => {
  const purifiedHtml = useMemo(() => DOMPurify.sanitize(publicText), [publicText]);
  const bundle = useArb("HVHChecklistPantherResource");
  const venueDetail = bundle.formatMessage("Checklist-StartDate-Venue", {
    address: address,
  });
  const dateDetails = bundle.formatMessage("Checklist-StartDate-Date", {
    dateTime: startDateTime, //todo confirm start date time will be translated by SDA
  });
  return (
    <Col className="flyout-content" gridGap="1rem">
      <Col gridGap="0.5rem">
        <Text fontWeight="bold">{dateDetails}</Text>
        <Text fontWeight="bold">{venueDetail}</Text>
      </Col>
      <Text>
        <div className="sf-html-container" dangerouslySetInnerHTML={{ __html: purifiedHtml }}></div>
      </Text>
    </Col>
  );
};
